import { GridSpaceDataType, PositionType } from 'data/types';
import { spaceToAbsolutePolygon } from 'utils/polygon-shared-edges';

export function shouldUseOpenToOutline(
  isPolygonSpace: boolean,
  openTo: readonly string[] | undefined,
  easyMode = false
): boolean {
  if (easyMode) {
    return false;
  }
  return isPolygonSpace || (openTo?.length ?? 0) > 0;
}

export function getGridSpaceOutlineVertices(
  gridSpace: Pick<GridSpaceDataType, 'vertices' | 'position'>
): PositionType[] {
  return spaceToAbsolutePolygon(gridSpace, 1, { relative: true });
}
